var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65301 2.16669C3.27967 2.16669 3.01301 2.47335 3.01301 2.84669C3.01301 3.21335 3.30634 3.51335 3.67967 3.51335H7.39967L6.53301 4.37335C6.26634 4.63335 6.26634 5.05335 6.53301 5.31335C6.79301 5.57335 7.21301 5.57335 7.47301 5.31335L9.47301 3.31335C9.59301 3.18669 9.66634 3.01335 9.66634 2.84002C9.66634 2.66002 9.59301 2.49335 9.46634 2.36669L7.46634 0.366687C7.19968 0.10002 6.77968 0.10002 6.51968 0.366687C6.25301 0.626687 6.25301 1.04669 6.51968 1.30669L7.37967 2.16669H3.65301Z",
    fill: "#F07300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34634 8.83335C6.71968 8.83335 6.98634 8.52669 6.98634 8.15335C6.98634 7.78669 6.69301 7.48669 6.31967 7.48669H2.59967L3.46634 6.62669C3.73301 6.36669 3.73301 5.94669 3.46634 5.68669C3.20634 5.42669 2.78634 5.42669 2.52634 5.68669L0.526341 7.68669C0.406341 7.81335 0.333008 7.98669 0.333008 8.16002C0.333008 8.34002 0.406341 8.50669 0.533007 8.63335L2.53301 10.6334C2.79967 10.9 3.21967 10.9 3.47967 10.6334C3.74634 10.3734 3.74634 9.95335 3.47967 9.69335L2.61967 8.83335L6.34634 8.83335Z",
    fill: "#F07300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/Transfer.6f7e115f.svg";
export { ForwardRef as ReactComponent };